import React from "react";
import PropTypes from "prop-types";

const GetDataEnabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="31"
      height="25"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1818 7.45456C26.1386 7.45456 24.9973 9.48365 25.4623 10.9914L20.46 16.0077C20.0373 15.8809 19.4173 15.8809 18.9945 16.0077L15.4014 12.4146C15.8805 10.9068 14.7391 8.86365 12.6818 8.86365C10.6386 8.86365 9.48318 10.8927 9.96227 12.4146L3.53682 18.8259C2.02909 18.3609 0 19.5023 0 21.5455C0 23.0955 1.26818 24.3636 2.81818 24.3636C4.86136 24.3636 6.00273 22.3346 5.53773 20.8268L11.9491 14.4014C12.3718 14.5282 12.9918 14.5282 13.4145 14.4014L17.0077 17.9946C16.5286 19.5023 17.67 21.5455 19.7273 21.5455C21.7705 21.5455 22.9259 19.5164 22.4468 17.9946L27.4632 12.9923C28.9709 13.4573 31 12.3159 31 10.2727C31 8.72274 29.7318 7.45456 28.1818 7.45456Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M19.7273 8.86363L21.0518 5.94681L23.9545 4.63636L21.0518 3.32591L19.7273 0.409088L18.4309 3.32591L15.5 4.63636L18.4309 5.94681L19.7273 8.86363Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M3.52273 11.6818L4.22727 8.86364L7.04545 8.15909L4.22727 7.45455L3.52273 4.63637L2.81818 7.45455L0 8.15909L2.81818 8.86364L3.52273 11.6818Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="15.5"
          y1="7.45456"
          x2="15.5"
          y2="24.3636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4871F0" />
          <stop offset="1" stop-color="#4AEAEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="19.7273"
          y1="0.409088"
          x2="19.7273"
          y2="8.86363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4871F0" />
          <stop offset="1" stop-color="#4AEAEB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="3.52273"
          y1="4.63637"
          x2="3.52273"
          y2="11.6818"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4871F0" />
          <stop offset="1" stop-color="#4AEAEB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

GetDataEnabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

GetDataEnabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default GetDataEnabled;
